import { motion } from 'framer-motion';
import type { Easing } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const ease: Easing = 'easeOut';

const reveal = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: '-40px' },
  transition: { duration: 0.5, ease },
};

const HowItWorksSection = () => {
  const { t } = useTranslation();

  const steps = [
    { number: '01', title: t('brooklyn.howItWorks.step1_title'), description: t('brooklyn.howItWorks.step1_desc') },
    { number: '02', title: t('brooklyn.howItWorks.step2_title'), description: t('brooklyn.howItWorks.step2_desc') },
    { number: '03', title: t('brooklyn.howItWorks.step3_title'), description: t('brooklyn.howItWorks.step3_desc') },
  ];

  return (
    <section className="section-padding bg-background">
      <div className="content-width">
        <motion.h2
          {...reveal}
          className="text-display text-section text-foreground mb-16 text-center md:text-left"
        >
          {t('brooklyn.howItWorks.title')}
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16">
          {steps.map((step, i) => (
            <motion.div
              key={step.number}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-50px' }}
              transition={{ duration: 0.5, ease, delay: i * 0.08 }}
              className="border-t border-border pt-8"
            >
              <span className="text-ui text-xs text-muted-foreground tracking-wider-ui mb-4 block">
                {step.number}
              </span>
              <h3 className="font-display text-xl md:text-2xl text-foreground mb-4">
                {step.title}
              </h3>
              <p className="text-body-fluid text-muted-foreground leading-relaxed-body">
                {step.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
